// extracted by mini-css-extract-plugin
module.exports = {"foodItemCardList":"FoodItemCardList_foodItemCardList__28mKP","foodItemCard":"FoodItemCardList_foodItemCard__1OztQ"};